import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=e6c1905e&scoped=true&"
import script from "./DashboardLayout.vue?vue&type=script&lang=js&"
export * from "./DashboardLayout.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&id=e6c1905e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c1905e",
  null
  
)

export default component.exports